import React, { useContext, useEffect, useRef, useState } from 'react'
import GifLoader from '../components/ui/gifLoader';
import {
    FormControl,
    InputLabel,
    Input,
    FormHelperText,
    Box,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    Card
} from '@mui/material';
import MUIDataTable from "mui-datatables";
import logo4 from "../assets/img/logo4.png";
import Slide from "@mui/material/Slide";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { services } from '../services/api';
import { NotificacionContext } from "../context/notificacion_context";
import { useHistory } from "react-router-dom";



function PadronTrans() {
    const notification = useContext(NotificacionContext);
    let history = useHistory();

    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState(0);
    const containerRef = useRef(null)
    const [state, setState] = useState({
        placa: "",
        serie: "",
        consesion: "",
    });
    const [responsePadron, setResponsePadron] = useState([])
    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    };

    const [suma, setSuma] = useState(0)

    const apiConsulta = async () => {
        if (state.serie === "") {
            notification.showNotification(
                "warning",
                "Campos Vacíos",
                "Por favor rellene el campo serie",
                null,
                4
            );

        } else {

            setLoading(true)
            let recaptcha_token = "";

            await ReactRecaptcha3.getToken().then(token => {
                recaptcha_token = token

            }, error => {
                // handle error here
                console.log(error)
            })
            let body = {
                "serie": state.serie,
                "placa": state.placa,
                "concesion": state.consesion,
                "tipo": 1,
                "recaptcha_token": recaptcha_token
            }
            let apiPadron = await services('POST', 'concesion/generar', body)
            
            if (apiPadron.status === 422) {
                notification.showNotification(
                    "warning",
                    "Error",
                    apiPadron.data,
                    null,
                    4
                );
            } else if (apiPadron.status === 200) {
                if(apiPadron.data.TB_CALC_DETALLE === undefined){
                    notification.showNotification(
                        "warning",
                        "Error",
                        "No existe Adeudo",
                        null,
                        4
                    );
                }else{

                    setValue(1)
                    
                    setResponsePadron(apiPadron.data)
                    let sumaResponse = 0
                    apiPadron?.data?.TB_CALC_DETALLE.forEach(element => {
                        sumaResponse = sumaResponse + parseFloat(element.IMPORTE_CONDICION)
                    })
                    setSuma(parseFloat(sumaResponse).toFixed(2))
                }
            }
        }

        setLoading(false)
    }

    const handleGenerar = async () => {
        setLoading(true)
        let recaptcha_token = "";

        await ReactRecaptcha3.getToken().then(token => {
            recaptcha_token = token

        }, error => {
            // handle error here
            console.log(error)
        })
        let body = {
            "serie": state.serie,
            "placa": state.placa,
            "concesion": state.consesion,
            "tipo": 2,
            "recaptcha_token": recaptcha_token
        }
        let apiPadron = await services('POST', 'concesion/generar', body)
        console.log(apiPadron)
        if (apiPadron.status === 422) {
            notification.showNotification(
                "warning",
                "Error",
                apiPadron.data,
                null,
                4
            );
        } else if (apiPadron.status === 200) {
            notification.showNotification(
                "success",
                "Orden Generada",
                apiPadron?.data?.mensaje,
                null,
                4
            );
            window.location.replace(apiPadron?.data?.url)
        }
        setLoading(false)
    }

    useEffect(() => {
        let isMounted = true
        if (isMounted) {
            ReactRecaptcha3.init(process.env.REACT_APP_RECAPTCHA_TOKEN).then(status => {
            })
            setLoading(false)
        }
        return () => {
            isMounted = false
        }
    }, [])

    const ListDatos = ({ title, data, divider = true }) => (
        <>
            <List sx={{ width: '100%', maxWidth: '210px', bgcolor: '#fbc8d3' }}>
                <ListItem alignItems="flex-start">
                    <ListItemText
                        primary={title}
                        sx={{ textAlign: 'center' }}
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', textAlign: 'center', display: 'block' }}
                                >
                                    <strong>{data}</strong>
                                </Typography>
                            </React.Fragment>
                        }
                    />
                </ListItem>
            </List>
            {/* {divider &&
                <Divider orientation="vertical" variant='middle' flexItem component="li" />
            } */}
        </>
    );
    const columns = [
        {
            name: "CANTIDAD",
            label: "Cantidad",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.CANTIDAD;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
        {
            name: "CLAVE",
            label: "Clave",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.CLAVE;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
        {
            name: "CONCEPTO",
            label: "Concepto",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.TXT_CONCEPTO;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
        {
            name: "PERIODO",
            label: "Periodo",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.PERIODO;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
        {
            name: "VALOR UNITARIO",
            label: "Valor Unitario",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.IMPORTE_CONDICION;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
        {
            name: "IMPORTE",
            label: "Importe",
            align: "center",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = responsePadron?.TB_CALC_DETALLE[dataIndex]?.IMPORTE_NETO_CONDICION;
                    return (
                        <div
                            style={{ height: "60px" }}
                            className={
                                i % 2 === 0
                                    ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            {id}
                        </div>
                    );
                },
            },
        },
    ]
    const options = {
        selectableRows: false,
        tableBodyHeight: "auto",
        textLabels: {
            body: {
                noMatch: "Lo sentimos, no hay coincidencias en la busqueda",
                toolTip: "Clasificar",
                columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
            },
            pagination: {
                next: "Siguiente",
                previous: "Anterior",
                rowsPerPage: "Filas por página:",
                displayRows: "de",
            },
            toolbar: {
                search: "Buscar",
                downloadCsv: "Descargar CSV",
                print: "Imprimir",
                viewColumns: "Ver columnas",
                filterTable: "Filtrar tabla",
            },
            filter: {
                all: "Todo",
                title: "Filtros",
                reset: "Restaurar",
            },
            viewColumns: {
                title: "Ver columnas",
                titleAria: "Mostrar/Ocultar columnas en la tabla",
            },
            selectedRows: {
                text: "columna(s) selecciona(as)",
                delete: "Eliminar",
                deleteAria: "Eliminar filas seleccionadas",
            },
        },
        download: false,
        print: false,
        responsive: "standard",
        downloadOptions: {
            
            filename: "tablaUsuarios.csv",
            filterOptions: {
                useDisplayedColumnsOnly: false,
                useDisplayedRowsOnly: false,
            },
        },
    };
    return (
        <>
            {loading && <GifLoader />}
            <div className={`my-auto mx-auto ${value === 0 ? 'w-impuesto' : ''} `}>
                <div
                    style={{ overflow: "hidden" }}
                    ref={containerRef}
                    className="d-flex justify-content-center align-items-center card m-3 text-center"
                >

                    <div className="d-none text-big mb-2 text-bold">

                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                centered
                                aria-label="basic tabs example"
                            >
                                <Tab  {...a11yProps(0)} />
                                <Tab  {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                    </div>



                    <div className="my-auto p-4">
                        {value === 0 && (
                            <Slide
                                direction="right"
                                in={value === 0}
                                container={containerRef.current}
                            >
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    <div
                                        className="d-flex flex-column flex-md-row justify-content-center align-items-center"
                                        style={{ alignItems: "center" }}
                                    >
                                        <img
                                            className="imgLogo4 mx-auto mb-3"
                                            alt="Imagen Decorativa"
                                            src={logo4}
                                            style={{
                                                width: "180px",
                                                Height: "180px",
                                                marginLeft: "80px",
                                            }}
                                        />
                                        <span className="h3 text-vinoGob text-bold sizeletrasgobTitle navidad ms-md-3">
                                            PADRÓN TRANSPORTISTAS REVALIDACIÓN
                                        </span>
                                    </div>

                                    {/* NOMINA */}
                                    <FormControl
                                        sx={{ marginTop: 3, width: 400, maxWidth: "100%" }}
                                    >
                                        <InputLabel htmlFor="my-input">Placa</InputLabel>
                                        <Input
                                            onChange={(event) => {
                                                const uppercasedValue =
                                                    event.target.value.toUpperCase();
                                                setState({ ...state, placa: uppercasedValue });
                                            }}
                                            onKeyPress={(event) => {
                                                // onlyLetter(event, 29);
                                            }}
                                            inputProps={{
                                                style: { textTransform: "uppercase" },
                                                maxLength: 30,
                                            }}
                                            id="nombre"
                                            name="nombre"
                                            aria-describedby="my-helper-text"
                                        />
                                        <FormHelperText id="my-helper-text">
                                            Ingresa tu Placa.
                                        </FormHelperText>
                                    </FormControl>

                                    <FormControl
                                        sx={{ marginTop: 3, width: 400, maxWidth: "100%" }}
                                    >
                                        <InputLabel htmlFor="my-input">
                                            Serie
                                        </InputLabel>
                                        <Input
                                            onChange={(event) => {
                                                setState({ ...state, serie: event.target.value });
                                            }}
                                            onKeyPress={(event) => {
                                                // onlyLetter(event, 29);
                                            }}
                                            inputProps={{ style: { textTransform: "uppercase" }, maxLength: 22, }}
                                            id="nombre"
                                            name="nombre"
                                            aria-describedby="my-helper-text"
                                        />
                                        <FormHelperText id="my-helper-text">
                                            Ingresa tu serie.
                                        </FormHelperText>
                                    </FormControl>

                                    <FormControl
                                        sx={{ marginTop: 3, width: 400, maxWidth: "100%" }}
                                    >
                                        <InputLabel htmlFor="my-input">
                                            Concesión
                                        </InputLabel>
                                        <Input
                                            onChange={(event) => {
                                                setState({ ...state, consesion: event.target.value });
                                            }}
                                            onKeyPress={(event) => {
                                                // onlyLetter(event, 29);
                                            }}
                                            inputProps={{ style: { textTransform: "uppercase" }, maxLength: 30, }}
                                            id="nombre"
                                            name="nombre"
                                            aria-describedby="my-helper-text"
                                        />
                                        <FormHelperText id="my-helper-text">
                                            Ingresa tu Concesión.
                                        </FormHelperText>
                                    </FormControl>

                                    <div
                                        className="cta cta--guinda mt-2"
                                        onClick={() => {
                                            apiConsulta()
                                        }}
                                    >
                                        Consultar
                                    </div>
                                </div>
                            </Slide>
                        )}
                        {value === 1 && (
                            <Slide
                                direction="left"
                                in={value === 1}
                                container={containerRef.current}
                            >
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    <div
                                        className="d-flex flex-column flex-md-row justify-content-center align-items-center"
                                        style={{ alignItems: "center" }}
                                    >
                                        <img
                                            className="imgLogo4 mx-auto mb-3"
                                            alt="Imagen Decorativa"
                                            src={logo4}
                                            style={{
                                                width: "80px",
                                                Height: "80px",
                                                marginRight: "20px",
                                            }}
                                        />
                                        <span className="h3 text-vinoGob text-bold sizeletrasgobTitle navidad ms-md-3">
                                            PADRÓN TRANSPORTISTAS REVALIDACIÓN
                                        </span>
                                    </div>

                                    {responsePadron?.TB_CALC_DETALLE?.length !== 0 &&
                                        <div
                                            className="cta cta--guinda mt-2 ml-auto"
                                            onClick={() => {
                                                handleGenerar();
                                            }}
                                        >
                                            Generar Orden de Pago
                                        </div>

                                    }
                                    <div className='d-flex flex-column w-100'>
                                        <h4 className='text-center'>Datos del Contribuyente</h4>
                                        <p className='text-right'>Objeto Contrato: <strong>{responsePadron?.ES_OPAG?.OBJ_CONTRATO ?? ''}</strong> </p>
                                        <Card className='padronPink d-flex flex-row flex-wrap mt-3 justify-content-around'>
                                            <ListDatos title='Concesión' data={responsePadron?.ES_OPAG?.CONCESION ?? ''} />
                                            <ListDatos title='Estatus' data={responsePadron?.ES_OPAG?.ESTATUS ?? ''} />
                                            <ListDatos title='Grupo' data={responsePadron?.ES_OPAG?.GRUPO ?? ''} />
                                            <ListDatos title='Tipo de Servicio' data={responsePadron?.ES_OPAG?.TIPO_SERV ?? ''} />
                                            <ListDatos title='Modalidad' data={responsePadron?.ES_OPAG?.MODALIDAD ?? ''} />
                                            <ListDatos title='RFC' data={responsePadron?.ES_OPAG?.RFC ?? ''} />
                                            <ListDatos title='Nombre' data={responsePadron?.ES_OPAG?.NOMBRE ?? ''} />
                                            <ListDatos title='Placa' data={responsePadron?.ES_OPAG?.PLACA ?? ''} />
                                            <ListDatos title='Serie' data={responsePadron?.ES_OPAG?.SERIE ?? ''} divider={false} />
                                        </Card>

                                        <p className='text-right mt-5'>Importe Total: <strong>
                                            {suma} MXN
                                        </strong> </p>
                                        <MUIDataTable
                                            style={{ Overflow: "hidden" }}
                                            className='mt-4 TitleRight'
                                            title={"Detalle del adeudo"}
                                            data={responsePadron?.TB_CALC_DETALLE}
                                            columns={columns}
                                            options={options}
                                        />
                                    </div>


                                    <div
                                        className="cta cta--guinda mt-2"
                                        onClick={() => {
                                            setValue(0)
                                            setState({
                                                placa: '',
                                                serie: '',
                                                consesion: '',
                                            })
                                        }}
                                    >
                                        Cancelar
                                    </div>
                                </div>
                            </Slide>
                        )}
                    </div>

                </div>
            </div>
        </>
    )
}

export default PadronTrans